import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
  GET_MODELSETPOINTS,
  MODELSETPOINTS_IS_LOADING,
  MODELSETPOINTS_MANAGEMENT_ERROR,
  MODELSETPOINTS_SET_CURRENT_PAGE,
  MODELSETPOINTS_SET_PAGE_FILTER,
  MODELSETPOINTS_SET,
  MODELSETPOINTS_UPDATE_SAVE_STATUS,
  MODELSETPOINTS_SET_CHANGE,
  MODELSETPOINTS_SET_FILTERED_RESULTS,
  UPDATE_MODELSETPOINTS_MODEL_SHOW_SCREEN,
  MODELSETPOINTS_CLEANUP
} from '../constants/index';

import {
  MODELSETPOINTS_MANAGEMENT,
  CREATE_MODELSETPOINTS,
  UPDATE_MODELSETPOINTS,
  DELETE_MODELSETPOINTS
} from '../constants/logs';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

export const getModelSetpointsThunk = (modelCategoryId, modelId,  widgetCode) => dispatch => {
  dispatch(getModelSetpoints(modelCategoryId, modelId, widgetCode));
};

export const getModelSetpoints = (modelCategoryId, modelId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}/management/model/setpoint`,
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setAllModelSetpointsListThunk(retData),
    onFailure: err => setModelSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {ModelCategoryId: modelCategoryId, ModelId: modelId},
    widgetcode: widgetCode
  });

export const setAllModelSetpointsListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelSetpoints = (retData && retData.modelSetpoints) || [];
  dispatch(setAllModelSetpointsList(messageCode, modelSetpoints));
};

export const setAllModelSetpointsList = (messageCode, modelSetpoints) => ({
  type: GET_MODELSETPOINTS,
  payload: {
    data: {
      modelSetpointList: modelSetpoints,
      filteredResults: modelSetpoints,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const setLoadingStatus = isLoading => ({
  type: MODELSETPOINTS_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const setModelSetpointsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setModelSetpointsError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelSetpointsError(messageCode, false));
  }, 2500);
};

export const setModelSetpointsError = (messageCode, status) => {
  return {
    type: MODELSETPOINTS_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessfull: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const setCurrentPage = currentPage => ({
  type: MODELSETPOINTS_SET_CURRENT_PAGE,
  payload: { currentPage }
});

export const setPageFilter = filter => ({
  type: MODELSETPOINTS_SET_PAGE_FILTER,
  payload: { filter }
});

export const describeModelSetpointsThunk = (modelId, modelSetpointId, widgetCode) => dispatch => {
  dispatch(describeModelSetpoints(modelId, modelSetpointId, widgetCode));
};

export const describeModelSetpoints = (modelId, modelSetpointId,  widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}/management/model/setpoint`,
    data: {
      ModelId: modelId,
      ModelSetpointId: modelSetpointId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setModelSetpointsThunk(retData),
    onFailure: err => setModelSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setModelSetpointsThunk = ({retData}) => dispatch => {
  dispatch(setModelSetpoints(retData));
};

export const setModelSetpoints = data => ({
  type: MODELSETPOINTS_SET,
  payload: data
});

export const saveModelSetpointsThunk = (modelSetpoints, widgetCode) => dispatch => {
  let url = '/management/model/setpoint/save';
  let actionName = modelSetpoints.MarkAsDeleted
    ? DELETE_MODELSETPOINTS
    : modelSetpoints.SetpointId === 0
    ? CREATE_MODELSETPOINTS
    : UPDATE_MODELSETPOINTS;
  let log = logEntry(MODELSETPOINTS_MANAGEMENT, actionName, modelSetpoints);
  dispatch(saveModelSetpoints(modelSetpoints, url, log, widgetCode));
};

export const saveModelSetpoints = (modelSetpoints, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setModelSetpointsStatusThunk(retData, modelSetpoints),
    onFailure: err => setModelSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      modelSetpoint: modelSetpoints,
      log: log
    },
    widgetcode: widgetCode
  });

export const setModelSetpointsStatusThunk = (retData, modelSetpoints) => dispatch => {
  dispatch(setModelSetpointsStatus(retData, true, false));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelSetpointsStatus(retData, false, !modelSetpoints.MarkAsDeleted));
  }, 2500);
};

export const setModelSetpointsStatus = (retData, status, redirect) => ({
  type: MODELSETPOINTS_UPDATE_SAVE_STATUS,
  payload: {
    data: {
      modelSetpointList: retData.modelSetpoints,
      filteredResults: retData.modelSetpoints,
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      redirect: redirect,
      displayMessageCode: retData.message || ''
    }
  }
});

export const setModelSetpointsChangeThunk = retData => dispatch => {
  dispatch(setModelSetpointsChange(retData));
};

export const setModelSetpointsChange = retData => ({
  type: MODELSETPOINTS_SET_CHANGE,
  payload: retData
});

export const setModelSetpointsFilteredDataThunk = retData => dispatch => {
  dispatch(setModelSetpointsFilteredData(retData));
};

export const setModelSetpointsFilteredData = retData => ({
  type: MODELSETPOINTS_SET_FILTERED_RESULTS,
  payload: retData
});

export const setModelSetpointShowScreenStatusThunk = status => dispatch => {
  dispatch(setModelSetpointShowScreenStatus(status));
};

export const setModelSetpointShowScreenStatus = status => ({
  type: UPDATE_MODELSETPOINTS_MODEL_SHOW_SCREEN,
  payload: { showAddEditScreen: status }
})


export const resetModelSetpointsThunk = retData => dispatch => {
  dispatch(resetModelSetpoints(retData));
};

export const resetModelSetpoints = retData => ({
  type: MODELSETPOINTS_CLEANUP,
  payload: retData
});